import { FC } from 'react';
import { Col, Empty, Row } from 'antd';
import Explore from '@mui/icons-material/Explore';
import { Container } from '../../components/container/container';
import { PageBanner } from '../../components/page-banner/page-banner';
import { TitleSection } from '../../components/title-sections/title-sections';
import { BreadcrumbItem } from '../../components/breadcrumb/breadcrumb';
import { IAudience, IJourney } from '../../apis/journeys';
import { JourneyCard } from './journey-card/journey-card';

export interface JourneysProps {
  journeys?: IJourney[];
  audiences: IAudience[];
  selectedAudience?: string;
  onSelectAudience: (slug?: string) => void;
  onClickJourney: (slug: string) => void;
  breadcrumbs: BreadcrumbItem[];
}

export const Journeys: FC<JourneysProps> = ({
  journeys,
  audiences,
  selectedAudience,
  onSelectAudience,
  onClickJourney,
  breadcrumbs,
}) => (
  <div className="xvia-journeys">
    <PageBanner
      bannerTitle="Jornada do Cidadão"
      bannerImage={`${process.env.PUBLIC_URL}/images/banner/banner_letters_services.png`}
      breadcrumbs={breadcrumbs}
    />
    <Container className="xvia-journeys__container">
      <TitleSection
        titleSettings={{
          title: 'Escolha a sua jornada',
          colorTitle: '#202020',
          subtitle:
            'Serviços reunidos e organizados em etapas, do começo ao fim, por momento de vida',
          colorSubtitle: '#7B7B7B',
        }}
        iconSettings={{
          displayIcon: true,
          sectionIcon: <Explore />,
          iconColor: '#9E9E9E',
          iconSize: '40px',
        }}
      />

      {!!audiences.length && (
        <div className="xvia-journeys__filters">
          <button
            type="button"
            className={`xvia-journeys__filter${
              !selectedAudience ? ' xvia-journeys__filter--active' : ''
            }`}
            onClick={() => onSelectAudience(undefined)}
          >
            Todas
          </button>
          {audiences.map((audience) => (
            <button
              key={audience.id}
              type="button"
              className={`xvia-journeys__filter${
                selectedAudience === audience.slug
                  ? ' xvia-journeys__filter--active'
                  : ''
              }`}
              onClick={() => onSelectAudience(audience.slug)}
            >
              {audience.name}
            </button>
          ))}
        </div>
      )}

      <Row gutter={[24, 24]}>
        {journeys?.map((journey) => (
          <Col xs={24} sm={24} md={12} lg={8} xl={8} xxl={8} key={journey.id}>
            <JourneyCard journey={journey} onClick={onClickJourney} />
          </Col>
        ))}
      </Row>

      {!journeys?.length && <Empty description="Nenhuma jornada encontrada" />}
    </Container>
  </div>
);
